export default __webpack_public_path__ + "static/media/safari_icon_active.ae592073.png";